import { getCallParams, getFileCallParams, makeCall } from "utils/service";
import urls from "global/constants/UrlConstants";

export interface WebForm {
  id: string;
  name: string;
  templateId: string;
  templateName: string;
  signerId: number;
  cdnUrl?: string;
  htmlKey?: string;
  unlayerJson?: string;
  /** Set on a web form built with the AI designer: it opens the AI chat, not Unlayer. */
  aiDesignId?: string;
  aiSessionId?: string;
  status: "Active" | "Archived";
  createdOn: string;
  updatedOn: string;
}

export const fetchUnlayerScaffold = async (
  templateId: string,
  signerId: number,
): Promise<any> => {
  const url = `${urls.FETCH_UNLAYER_SCAFFOLD}/${templateId}/signer/${signerId}?t=${new Date().getTime()}`;
  const callParams = await getCallParams("GET");
  return await makeCall(url, callParams);
};

export const createWebForm = async (formData: FormData): Promise<WebForm> => {
  const url = urls.CREATE_WEBFORM;
  const callParams = await getFileCallParams("POST", formData);
  return await makeCall(url, callParams);
};

export const fetchWebForms = async (
  pageNumber: number | "ALL" = 1,
  pageSize: number | "ALL" = 10,
): Promise<WebForm[]> => {
  const url = `${urls.GET_WEBFORM}/limit/${pageSize}/page/${pageNumber}`;
  const callParams = await getCallParams("POST", []);
  return await makeCall(url, callParams);
};

export const fetchWebFormsCount = async (): Promise<number> => {
  const url = `${urls.GET_WEBFORM}/count`;
  const callParams = await getCallParams("GET");
  const response = await makeCall(url, callParams);
  if (typeof response === "number") return response;
  return response?.count ?? response?.total ?? 0;
};

export const fetchWebFormsByTemplate = async (
  templateId: string,
): Promise<WebForm[]> => {
  const url = `${urls.GET_WEBFORMS_BY_TEMPLATE}/${templateId}`;
  const callParams = await getCallParams("GET");
  return await makeCall(url, callParams);
};

export const getWebFormDetails = async (
  id: string,
): Promise<WebForm | null> => {
  const url = `${urls.GET_WEBFORM}/${id}`;
  const callParams = await getCallParams("GET");
  return await makeCall(url, callParams);
};

export const updateWebForm = async (
  id: string,
  formData: FormData,
): Promise<WebForm> => {
  const url = `${urls.UPDATE_WEBFORM}/${id}`;
  const callParams = await getFileCallParams("PATCH", formData);
  return await makeCall(url, callParams);
};

export const deleteWebForm = async (id: string): Promise<void> => {
  const url = `${urls.DELETE_WEBFORM}/${id}`;
  const callParams = await getCallParams("DELETE");
  return await makeCall(url, callParams);
};
